// Centralized image assets - using branded flame logo
// Logo Usage Guide:
// - equiforgeLogo: Original classic wordmark (legacy/fallback)
// - equiforgeLogoFlat: Branded flame logo with chart elements and TM mark (PRIMARY)
// - equiforgeFlameLogo: Branded flame logo with chart elements and TM mark (same as equiforgeLogoFlat)
// - equiforgeLogo3d: 3D yellow/purple wordmark for marketing/about pages
// - equiforgeLogoYellowPurple: Alias for 3D logo (backward compatibility)
// - offerscopeLogo: OfferScope product branding
// - equiforgebranded: Full branded lockup

import equiforgeLogoImg from './logos-embedded/equiforge-original-embedded.png';
import equiforgeLogo3dImg from './logos-embedded/equiforge-3d-embedded.png';
import equiforgeBrandedFlameImg from './logos-embedded/flame-only-embedded.png';
import offerscopeLogoImg from './logos-embedded/offerscope-embedded.png';
import equiforgeBrandedImg from './logos-embedded/equiforge-branded-embedded.png';
// Using public path for phil-pose2 image
const philFounderImg = '/photobucket/phil-pose2.jpeg';

export const images = {
  equiforgeLogo: equiforgeLogoImg,                    // Original classic wordmark
  equiforgeLogoFlat: equiforgeBrandedFlameImg,        // Branded flame logo (PRIMARY - RECOMMENDED)
  equiforgeFlameLogo: equiforgeBrandedFlameImg,       // Branded flame logo (same as equiforgeLogoFlat)
  equiforgeLogo3d: equiforgeLogo3dImg,                // 3D yellow/purple wordmark
  equiforgeLogoYellowPurple: equiforgeLogo3dImg,      // Alias for backward compatibility
  offerscopeLogo: offerscopeLogoImg,                  // OfferScope branding
  philFounder: philFounderImg,                        // Founder photo
  equiforgebranded: equiforgeBrandedImg,              // Full branded lockup
} as const;
export default images;
